import { signal } from '@preact/signals';
import { MENU, type Rota } from './permissoes';

const VALIDAS = new Set<string>(MENU.map((m) => m.id));

function ler(): Rota {
  const parte = location.hash.replace(/^#\/?/, '').split(/[/?]/)[0] ?? '';
  return (VALIDAS.has(parte) ? parte : 'painel') as Rota;
}

/** Rota atual, sincronizada com o hash da URL (#/acoes). O botão "voltar" do navegador funciona. */
export const rota = signal<Rota>(ler());

window.addEventListener('hashchange', () => {
  rota.value = ler();
});

export const irPara = (r: Rota) => {
  location.hash = `#/${r}`;
};
